// Import model
import { FilterOtgUserRequest } from '../models/FilterOtgUserRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { OtgUserCondition } from '../models/OtgUserCondition';
import { OtgUserFields } from '../models/OtgUserFields';
import { OtgUserIndexedFields } from '../models/OtgUserIndexedFields';

// Import dependency serializers (for complex types)
import { OtgUserConditionSerializer } from './OtgUserConditionSerializer';
import { OtgUserFieldsSerializer } from './OtgUserFieldsSerializer';
import { OtgUserIndexedFieldsSerializer } from './OtgUserIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for FilterOtgUserRequest - handles JSON serialization and deserialization with type validation
 */
export class FilterOtgUserRequestSerializer {
  /**
   * Deserializes a JSON string into a FilterOtgUserRequest instance
   */
  static deserialize(json: string): FilterOtgUserRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a FilterOtgUserRequest instance
   */
  static fromObject(obj: any): FilterOtgUserRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to FilterOtgUserRequest');
    }


    const instance: FilterOtgUserRequest = {
      top: obj['top'] as number | undefined,
      skip: obj['skip'] as number | undefined,
      orderBy: obj['orderBy'] as OtgUserIndexedFields | undefined,
      reverseOrder: obj['reverseOrder'] as boolean | undefined,
      view: obj['view'] as string | undefined,
      fields: obj['fields'] ? (obj['fields'] as any[]).map((item: any) =>
        item as OtgUserFields
      ) : [] as any,
      criteria: obj['criteria'] ? (obj['criteria'] as any[]).map((item: any) =>
        OtgUserConditionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of FilterOtgUserRequest instances
   */
  static deserializeArray(json: string): FilterOtgUserRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a FilterOtgUserRequest instance to a JSON string
   */
  static serialize(instance: FilterOtgUserRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a FilterOtgUserRequest instance to a plain object
   */
  static toObject(instance: FilterOtgUserRequest): any {
    return {
      'top': instance.top,
      'skip': instance.skip,
      'orderBy': instance.orderBy,
      'reverseOrder': instance.reverseOrder,
      'view': instance.view,
      'fields': instance.fields?.map((item: any) =>
        item
      ),
      'criteria': instance.criteria?.map((item: any) =>
        OtgUserConditionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of FilterOtgUserRequest instances to a JSON string
   */
  static serializeArray(instances: FilterOtgUserRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
